// Same rule the backend applies to DISCORD_JOIN_LINK for the homepage chat
// panel (DiscordChatService::INVITE_PREFIXES) - the deploy feeds that one
// value into VITE_DISCORD_URL, so both buttons agree on what counts as set.
const INVITE_PREFIXES = ['https://discord.gg/', 'https://discord.com/invite/'] as const;

// A runtime placeholder (`__VITE_*__`) the container never substituted.
const UNSUBSTITUTED_PLACEHOLDER = /^__VITE_\w+__$/;

/**
 * The community Discord invite, or null when unset, left as an unreplaced
 * placeholder or not a Discord invite - callers hide the link then rather
 * than point it somewhere wrong.
 */
export function resolveDiscordUrl(raw: string | undefined): string | null {
  const url = (raw ?? '').trim();

  if (url === '' || UNSUBSTITUTED_PLACEHOLDER.test(url)) {
    return null;
  }

  const isInvite = INVITE_PREFIXES.some(
    (prefix) => url.startsWith(prefix) && url.length > prefix.length,
  );

  return isInvite ? url : null;
}
